import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const dropdown = (theme: Theme) => css`
  ${breakpoint.up('smMd')} {
    position: absolute;
    top: 100%;
    left: -30px;
    display: block;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-10px);
    transition:
      opacity 0.2s ease-out,
      transform 0.2s ease-out;

    background: ${theme.palette.background.primary};
    border-radius: ${size[8]} ${size[32]};
    box-shadow: 0 10px 40px rgba(130, 139, 153, 0.4);
    padding: ${size[54]};
    width: fit-content;
    max-width: calc(100vw - 15px);
    overflow: hidden;

    &::before {
      content: '';
      height: 6px;
      background: ${theme.palette.brand[500]};
      width: 90px;
      display: block;
      position: absolute;
      border-radius: 3px;
      top: -3px;
      left: 30px;
    }
  }
`

export const content = css`
  display: flex;
  flex-direction: column;
  gap: ${size[28]};
`

export const inlineContent = css`
  flex-direction: row;
`

export const list = css`
  a span {
    color: #1a0826;
  }
`
